import React from "react";
import { Add, Subtract } from "grommet-icons";
import { Box, CheckBox, Collapsible, Text } from "grommet";
import { ListGroup, ListGroupItem } from 'reactstrap';

export default class TreeListView extends React.Component {
    state = {};

    toggle = event => {
        const id = event.target.getAttribute('id');

        this.setState(state => ({ [id]: !state[id] }));
    }

    mapper = (nodes, callback, parentId, lvl) => {
        return nodes.map((node, index) => {
            const id = `${node.text}-${parentId ? parentId : 'top'}`.replace(/[^a-zA-Z0-9-_]/g, '');
            const item = <Box key={id}>
                <ListGroupItem style={{ zIndex: 0 }} className={`${parentId ? `rounded-0 ${lvl ? 'border-bottom-0' : ''}` : ''}`}>
                    <Box fill direction="row" pad={{ left: `${15 * lvl}px` }} gap="xsmall">
                        {node.children && node.children.length > 0 &&
                            <Box fill="horizontal" direction="row" onClick={(event) => { callback(event, node); }} gap="small">
                                <Box pad={{ top: 'xsmall' }}>
                                    {node.isSelected ? <Subtract size="small" /> : <Add size="small" />}
                                </Box>
                                <Box>
                                    <Text size="small" weight={(node.isSelected || node.children.some((child) => child.isSelected)) ? "bold" : "normal"}>{node.text}</Text>
                                </Box>
                                <Box fill>
                                    <Text alignSelf="end" size="small">{`${node.children.filter((child) => child.isSelected).length} items selected`}</Text>
                                </Box>
                            </Box>
                        }
                        {(!node.children || node.children.length === 0) && <CheckBox checked={node.isSelected} label={node.text} onChange={(event) => callback(event, node)} />}
                    </Box>
                </ListGroupItem>
                {node.children && node.children.length !== 0 &&
                    <Collapsible open={node.isSelected}>
                        {this.mapper(node.children, callback, id, (lvl || 0) + 1)}
                    </Collapsible>
                }
            </Box>

            return item;
        });
    }

    render() {
        return (
            <ListGroup>
                {this.mapper(this.props.data, this.props.callback)}
            </ListGroup>
        )
    }
}
